<template>
  <div style="">
    <div style="color:red;">
      app消息需要配合权限配置使用，若缺少对应权限，点击通知时将不能正常使用。
    </div>
    <el-form
      ref="form"
      :model="form"
      :rules="rules"
      label-width="160px"
    >
      <el-row>
        <el-col :span="24">
          <div class="grid-content bg-purple">
            <el-form-item
              v-for="config in form.roleConfigList"
              :key="config.code"
              :label="config.configName"
              style="margin-right:15px"
            >
              <el-switch
                v-model="config.configValue"
                active-color="#13ce66"
                inactive-color="#DDDDDD"
                active-value="1"
                inactive-value="0"
              />
            </el-form-item>
          </div>
        </el-col>
      </el-row>
    </el-form>
    <div
      slot="footer"
      class="dialog-footer"
    >
      <el-button @click="funcCancel">
        取 消
      </el-button>
      <el-button
        type="primary"
        @click="funcSubmit"
      >
        确 定
      </el-button>
    </div>
  </div>
</template>
<script>
import request from '@/utils/request'
export default {
  props:{
    parentData: {
      type: Object,
      default() {
        return {
          partyCode: "",
          branchCode: "",
        };
      },
    },
  },
  data() {
    return {
      emptyForm: {},
      form: {
        roleCode: '',
        roleConfigList: []
      },
      rules: {
        roleName: [
          { required: true, message: '请输入角色名称', trigger: 'blur' },
          
        ]
      }
    }
  },
  created() {
    // 保存空表单对象
    this.emptyForm = JSON.parse(JSON.stringify(this.form))
  },
  methods: {
    // 获取页面信息
    getInfo(code) {
      // 查询到数据之前先展示空表单
      this.form = JSON.parse(JSON.stringify(this.emptyForm))
      this.form.roleCode = code
      request({ url: `/ntocc-basic-api/roleConfig/getShipmentAppPermission`, method: 'get', params: { 'roleCode': code,  shipmentCompanyCode: this.parentData.partyCode, branchCode:this.parentData.branchCode}}).then(response => {
        let data = response.data
        data.map((item)=>{
          item.gmtCreated = null
          item.gmtModified = null
        })
        this.form.roleConfigList = data
      })
    },
    // 提交
    funcSubmit() {
      const data = this.form.roleConfigList
      request({ url: '/ntocc-basic-api/roleConfig', method: 'put', data }).then(response => {
        this.$message({ message: response.msg, type: 'success' })
        this.funcCancel()
      })
    },
    // 取消
    funcCancel() {
      this.$emit('fatherCancelMethod', 'appNotice')
    }

  }
}
</script>
<style lang="scss" scoped>
  .dialog-footer {
    margin:15px 0 15px 0;
    width: 175px;
    float: right;
  }
</style>
